
const url = `${process.env.REACT_APP_BASEURL}/api/admin/dashboard`;
 
export const getDashboardData = async () => {
    try {
      const response = await fetch(url, {
        method: "Get",
        headers: {
          "Content-Type": "application/json"
        }
      });
  
      if (!response.ok) {
        throw new Error("Failed to fetch data. Please try again.");
      }
  
      return await response.json();
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
 
  